import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "@/components/Card.tsx";
import { getIdFromURL } from "vue-youtube-embed";
import { CreateElement } from "vue";
import { Module } from "@/store/enums.ts";
import { fetchAllItems } from "@/views/talk2mejr/StorageHandler";

@Component
export default class WritingTask1Intro extends Vue {
  private goNext = false;
  private videoData: any; // { url: string; name: string }
  private balaTasks: any;

  private async _getData() {
    return await fetchAllItems(`res/protected/writing_task_1/`);
  }

  created() {
    this.videoData = null;
    this.balaTasks = this.$store.getters.balaSections;
  }

  async mounted() {
    this.videoData = await this._getData();
    this.$forceUpdate();
  }

  enableNext() {
    this.goNext = true;
  }

  render(h: CreateElement) {
    return (
      <Card
        title={this.balaTasks[7].task + ": " + this.balaTasks[7].name}
        mod={Module.BALA}
      >
        <div slot="mainContent" style={{ textAlign: "center" }}>
          <p>Watch the video below.</p>
          <v-row justify="center">
            <video
              controls
              width="600"
              onEnded={() => {
                this.enableNext();
              }}
            >
              <source src={this.videoData[1].url}>
                {" "}
                speed.
              </source>
            </video>
          </v-row>
          <p style={{ marginTop: "10px" }}>
            Click <i>Next</i> when you are finished the video.
          </p>
        </div>
        <div slot="actions">
          <v-btn
            disabled={!this.goNext}
            color="secondary"
            to={{ name: "balaWT1Questions" }}
          >
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(this.$store.getters.progressBala)}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }
}

const component = WritingTask1Intro;
